// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".steps .tabs .tab[data-v-13e44d54] {\n  font-size: 11px;\n  padding: 4px 6px;\n  max-width: 99px;\n  text-transform: uppercase;\n}\n.steps .actions .steps-control[data-v-13e44d54] {\n  margin: 0 6px;\n}\n[data-v-13e44d54] .sida-modal {\n  max-width: 900px;\n}\n", ""]);
// Exports
module.exports = exports;
